import React from 'react';
import { Link } from 'react-router-dom';
interface CtaLinkProps {
  children: React.ReactNode;
  /** In-app route (React Router). */
  to?: string;
  /** Anchor or external URL. */
  href?: string;
  variant?: 'primary' | 'secondary' | 'dark';
  size?: 'medium' | 'large';
  external?: boolean;
  className?: string;
  onClick?: () => void;
}
const VARIANTS = {
  primary: 'bg-apple-blue text-white hover:bg-apple-blueHover',
  secondary: 'bg-white text-apple-black border border-gray-300 hover:bg-gray-50 hover:border-gray-400',
  dark: 'bg-apple-black text-white hover:bg-gray-800'
};
const SIZES = {
  medium: 'min-h-[44px] px-5 text-sm',
  large: 'min-h-[52px] px-8 text-base'
};
export function CtaLink({
  children,
  to,
  href,
  variant = 'primary',
  size = 'large',
  external = false,
  className = '',
  onClick
}: CtaLinkProps) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors duration-200 ${VARIANTS[variant]} ${SIZES[size]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} onClick={onClick} data-id="element-63" data-mp="344ypnlbp1bk">
        {children}
      </Link>;
  }
  return <a href={href} className={classes} onClick={onClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} data-id="element-64" data-mp="81exhtulqpc2">
      {children}
      {external && <span className="sr-only" data-id="element-65" data-mp="hshw8p026s86">(otvorí sa v novom okne)</span>}
    </a>;
}